/* eslint-disable max-len */
import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import cookie from 'react-cookies';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import Auth from '../../../utils/Auth';

import styles from './profile.module.scss';
import UserImg from '../../../icons/default_avatar.jpg';


class Profile extends Component {
    state = {
      profileDropdown: false
    };

  handleClick = () => {
    const { profileDropdown } = this.state;
    if (!profileDropdown) {
      // attach/remove event handler
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }
    this.setState(prevState => ({
      profileDropdown: !prevState.profileDropdown
    }));
  }

  handleOutsideClick = (e) => {
    // ignore clicks on the component itself
    try {
      if (this.node.contains(e.target)) {
        return;
      }
      this.handleClick();
    } catch (ex) {
      // nothing
    }
  }

  logout = () => {
    const { actionClear, history } = this.props;
    Auth.getInstance().logout();
    localStorage.clear();
    cookie.remove('backend_url', { path: '/' });
    actionClear();
    history.push('/');
  }

  render() {
    const { profileDropdown } = this.state;
    const { profile } = this.props;

    return (
      <div className={styles.profile} ref={(node) => { this.node = node; }}>
        <img src={profile.image ? profile.image : UserImg} alt={profile.fullname} />
        <button type="button" onClick={this.handleClick} style={{ minWidth: '70px' }}>
          { profile.fullname }
        </button>
        {profileDropdown && (
          <ul className={`${styles.dropdown} ${profileDropdown ? styles.open : ''}`}>
            <li className={styles.item}>
              <Link to="/profile">
                {' '}
                <FormattedMessage id="profile.settings.contactInfo" defaultMessage="Contact Information" />
              </Link>
            </li>
            {profile?.portal_login_with === 'email' && (
              <li className={styles.item}>
                <Link to="/changePassword">
                  {' '}
                  <FormattedMessage id="profile.settings.change_password" defaultMessage="Change Password" />
                </Link>
              </li>
            )}
            <li className={styles.item}>
              <Link to="/subscription">
                {' '}
                <FormattedMessage id="subscription" defaultMessage="Subscription" />
              </Link>
            </li>
            <li className={styles.item}>
              <button type="button" style={{ color: 'black' }} onClick={this.logout}>
                <FormattedMessage id="profile.settings.logout" defaultMessage="Log Out" />
              </button>
            </li>
          </ul>
        )}
      </div>
    );
  }
}

Profile.propTypes = {
  profile: PropTypes.shape({
    email: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string
  }).isRequired
};

export default withRouter(Profile);
